import Navbar from '../components/navbar';
import Footer from '../components/footer';
import { Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import placeholderImage from '../images/batiment.JPG';
import useAos from '../hooks/useAos';
import { useRealisation } from '../hooks/useRealisations';

const GROUP_SIZE = 4;

function DetailImage({ src, alt, layoutClass, aosDelay = 0 }) {
    return (
        <div className={`realisation-detail-image ${layoutClass}`} data-aos="fade-up" data-aos-delay={aosDelay}>
            <img src={src} alt={alt} />
        </div>
    );
}

function InfoRealisation() {
    const { id } = useParams();
    const { t } = useTranslation('common');
    const realisation = useRealisation(id);

    if (!realisation) {
        return <Navigate to="/404" replace />;
    }

    const images = realisation.images.length > 0 ? realisation.images : [placeholderImage];
    const groups = [];

    for (let index = 0; index < images.length; index += GROUP_SIZE) {
        groups.push(images.slice(index, index + GROUP_SIZE));
    }

    return (
        <div className="flex flex-column items-center justify-center py-96 px-64 overflow-hidden w-full" data-navbar-theme="light">
            <div className="pb-64 flex flex-column items-center justify-center pt-64 overflow-hidden w-full">
                <p className="text-title2 fustat text-medium m-0 text-center" data-aos="fade-up">{realisation.title}</p>
                <p className="text-subtitle fustat t-graymid text-medium m-0 text-center" data-aos="fade-up" data-aos-delay="150">{t('labels.client')} : {realisation.client}</p>
            </div>

            <div className="realisation-detail-gallery w-full mt-64">
                {groups.map((group, groupIndex) => (
                    <div key={groupIndex} className="realisation-detail-gallery__group">
                        {group[0] && (
                            <DetailImage
                                src={group[0]}
                                alt={realisation.title}
                                layoutClass="realisation-detail-image--wide"
                                aosDelay={groupIndex * 100}
                            />
                        )}

                        {(group[1] || group[2]) && (
                            <div className="realisation-detail-gallery__pair">
                                {group[1] && (
                                    <DetailImage
                                        src={group[1]}
                                        alt={realisation.title}
                                        layoutClass="realisation-detail-image--left-tall"
                                        aosDelay={groupIndex * 100 + 50}
                                    />
                                )}
                                {group[2] && (
                                    <DetailImage
                                        src={group[2]}
                                        alt={realisation.title}
                                        layoutClass="realisation-detail-image--right-offset"
                                        aosDelay={groupIndex * 100 + 100}
                                    />
                                )}
                            </div>
                        )}

                        {group[3] && (
                            <DetailImage
                                src={group[3]}
                                alt={realisation.title}
                                layoutClass="realisation-detail-image--wide-right"
                                aosDelay={groupIndex * 100 + 150}
                            />
                        )}
                    </div>
                ))}
            </div>

            <div className="w-80 flex flex-column items-center justify-center">
                <p className="text-title3 fustat t-blue text-normal m-0 pt-64 pb-32" data-aos="fade-up">{t('labels.description')}</p>
                <p className="text-subtitle outfit text-semilight m-0 pb-32 text-center" data-aos="fade-up" data-aos-delay="150">{realisation.description}</p>
                <div className="flex gap-32 items-center justify-center pt-64" data-aos="fade-up" data-aos-delay="300">
                    <p className="text-subtitle outfit text-regular m-0 text-center">{t('labels.projectCost')}</p>
                    <p className="text-subtitle outfit t-blue text-regular m-0 text-center">{realisation.prix}</p>
                </div>
            </div>
        </div>
    );
}

export default function InfoRealisationPage() {
    useAos();

    return (
        <>
            <Navbar />
            <InfoRealisation />
            <Footer />
        </>
    );
}
